import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import analytics from './services/analytics';

// Initialize analytics
analytics.init();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );